import React, { useMemo } from 'react';
import { View, type ImageSourcePropType } from 'react-native';
import { DefaultScreenContainer, HireBanner } from '~/components';
import INSURANCES from '~/utils/insurance';

import MarisaCareBanner from '~/assets/img/banners/marisa-takes-care-hire-banner.png';
import InsuranceAutoBanner from '~/assets/img/banners/auto-insurance-hire-banner.png';
import BagProtectionBanner from '~/assets/img/banners/bag-protection-hire-banner.png';
import IncomeProtectionBanner from '~/assets/img/banners/income-protection-hire-banner.png';
import UnemploymentProtectionBanner from '~/assets/img/banners/unemployment-assistance-desk.png';
import OdontoProtectionBanner from '~/assets/img/banners/odonto-protection-desk.png';

import type { InsuranceType } from '~/@types/insurance';
import { isWeb } from '~/utils/device';

interface DefaultBannerProps {
  banner: ImageSourcePropType;
  style?: string;
}

const defaultBannerPropsByType = (type: InsuranceType) => {
  let props = {} as DefaultBannerProps;

  const banners = {
    ['marisa-cuida']: MarisaCareBanner,
    ['marisa-auto']: InsuranceAutoBanner,
    ['bag-protection']: BagProtectionBanner,
    ['income-protection']: IncomeProtectionBanner,
    ['unemployment-assistance']: UnemploymentProtectionBanner,
    ['odonto-protection']: OdontoProtectionBanner,
  };

  props.banner = banners[type];

  if (type !== 'marisa-cuida' && !isWeb) {
    props.style = 'h-[140px]';
  }

  return props;
};

interface Props {
  type: InsuranceType;
  children: React.ReactNode;
  hiredBanner?: boolean;
  className?: string;
  showBanner?: boolean;
}

const DefaultContainer: React.FC<Props> = ({
  type,
  children,
  hiredBanner = false,
  className,
  showBanner = true,
}) => {
  const bannerProps = useMemo(() => defaultBannerPropsByType(type), [type]);

  const insuranceInformation = useMemo(
    () => INSURANCES.find((insurance) => insurance.type === type),
    [type]
  );

  if (!insuranceInformation) return null;

  return (
    <DefaultScreenContainer>
      {showBanner && (
        <HireBanner
          images={{
            mobile: insuranceInformation.banner.mobile,
            web: bannerProps.banner,
          }}
          insuranceName={insuranceInformation.name}
          insuranteDetail={insuranceInformation.description}
          horizontal={isWeb}
          hired={hiredBanner}
          className={bannerProps.style}
        />
      )}
      <View className={`px-6 ${className}`}>
        <View className="container mx-auto lg:w-[55%] lg:border lg:border-feedback-neutral-bkg lg:rounded-3xl lg:p-8">
          {children}
        </View>
      </View>
    </DefaultScreenContainer>
  );
};

export default DefaultContainer;
